$(document).ready(function(){
    $('.quicklinks.carousel').parent().addClass('carousel-parent-hotfix');
});